import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Article } from '../contentful/contentfulClient';
import './ArticleView.css';

interface ArticleViewProps {
    article: Article;
}

const options = {
    decodeEntities: true,
    transform: (node) => {
        if ( node.name && node.name.toLowerCase() === 'asset') {
            console.log(`${node}`);
        }
        return undefined;
    }
};

export const ArticleView: React.FC<ArticleViewProps> = ({ article: { title, author, body } }) => (
    <div className="article-view">
        <div className="article-view__title">{title}</div>
        <div className="article-view__body">{ReactHtmlParser(body, options)}</div>
        <div className="article-view__author">{author}</div>
    </div>
);


// WEBPACK FOOTER //
// ./src/article/ArticleView.tsx